// External
import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { connect } from 'react-redux';

// Internal
import { StoreState } from 'state/rootReducer';

type AuthenticatedRouteProps = {
  authorized: boolean,
} & RouteProps;

const AuthenticatedRoute = ({
  authorized = false,
  ...otherProps
}: AuthenticatedRouteProps): JSX.Element => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  authorized ? <Route {...otherProps} /> : <Redirect to="/usuarios/login/" />
);

AuthenticatedRoute.defaultProps = {
  authorized: false,
};

const mapStateToProps = (state: StoreState) => state.auth;

export default connect(mapStateToProps)(AuthenticatedRoute);
